<template>
  <div class="inline">
    <div v-if="type === 'submit-form'">
      <button
        type="submit"
        :class="`button button--primary ${extraClass}`"
        v-html="text"
      >
        {{ text }}
      </button>
    </div>
    <div v-else-if="type === 'login'">
      <button
        @click="$parent.login()"
        :class="`button button--primary ${extraClass}`"
        v-html="text"
      >
        {{ text }}
      </button>
    </div>
    <div v-else-if="type === 'register'">
      <button
        @click="$parent.register()"
        :class="`button button--primary ${extraClass}`"
        v-html="text"
      >
        {{ text }}
      </button>
    </div>
    <div v-else-if="type === 'submit'">
      <button
        @click="$parent.submit()"
        :class="`button button--primary ${extraClass}`"
        v-html="text"
      >
        {{ text }}
      </button>
    </div>
    <div v-else>
      <div v-if="path">
        <nuxt-link
          :to="localePath(path)"
          :class="`button button--primary ${extraClass}`"
          v-html="text"
          >{{ text }}</nuxt-link
        >
      </div>
      <div v-else>
        <a
          :href="link"
          :class="`button button--primary ${extraClass}`"
          v-html="text"
          target="_blank"
          >{{ text }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonPrimary',
  props: {
    type: {
      default: 'link',
      required: false,
      type: String
    },
    path: {
      default: '',
      required: false,
      type: String
    },
    link: {
      default: '',
      required: false,
      type: String
    },
    text: {
      default: '',
      required: true,
      type: String
    },
    extraClass: {
      default: '',
      required: false,
      type: String
    }
  }
}
</script>
